import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

function ClientOnly({ children, bannerHeight, ...delegated }) {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])
  if (!hasMounted) {
    return null
  }
  return (
    <div {...delegated}>
      {children && Array.isArray(children)
        ? children.map((child) => {
            if (child) {
              const newProps = { ...child.props, bannerHeight }
              const preparedChild = { ...child, props: newProps }
              return preparedChild
            }
            return child
          })
        : children}
    </div>
  )
}

ClientOnly.propTypes = {
  children: PropTypes.node.isRequired,
  bannerHeight: PropTypes.number,
}
ClientOnly.defaultProps = {
  bannerHeight: 0,
}
export default ClientOnly
